









import { Component, Vue } from 'vue-property-decorator';

import { ConfigsModuleMapper } from '@/store/modules/config';
import { MenuModuleMapper } from '@/store/modules/menu';
import FooterPhone from './footerPhone.vue';
import FooterSocial from './footerSocial.vue';
import FooterCopyright from './footerCopyright.vue';

const ignoreConfigOnJurisdiction = [
  'CURACAO', 'DENMARK',
];

const Mappers = Vue.extend({
  computed: {
    ...ConfigsModuleMapper.mapGetters(['configIsLoaded', 'contactsEnabled', 'jurisdiction']),
    ...MenuModuleMapper.mapGetters(['approvedForShowFooterMenuTree']),
  },
});

@Component({
  components: {
    FooterPhone,
    FooterSocial,
    FooterCopyright,
  },
})
export default class FooterComponent extends Mappers {
  get isShowFooterInfo() {
    const approvedUrl = this.approvedForShowFooterMenuTree;

    if (!approvedUrl || (this.jurisdiction && !ignoreConfigOnJurisdiction.includes(this.jurisdiction))) {
      return true;
    }

    let fullPath = this.$route.path;
    const lChar = fullPath.charAt(fullPath.length - 1);

    if (lChar !== '/') {
      fullPath = `${fullPath}/`;
    }

    return fullPath.indexOf(approvedUrl) !== -1;
  }
}
